module.exports = __webpack_public_path__ + "media/11_10.8b60ba03.wav";